import React from 'react'
import styled, { css } from 'styled-components'

const width = '23'
const height = '39'
const viewBox = '0 0 23 39'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      key="chevron"
      fill="currentColor"
      d="M6.4984 39C6.87366 39 7.24881 38.8584 7.53485 38.576L20.2872 25.9735C23.9043 22.3983 23.9043 16.6021 20.2872 13.0269L7.53485 0.423504C6.96033 -0.141846 6.03031 -0.140491 5.46058 0.423504L0.43017 5.39382C-0.143276 5.96023 -0.143276 6.87825 0.429485 7.44467L12.499 19.3723C12.5705 19.443 12.5705 19.5569 12.499 19.6269L0.430462 31.5545C-0.142298 32.1203 -0.142298 33.038 0.430462 33.604L5.46088 38.5757C5.74692 38.8581 6.12217 38.9997 6.49869 38.9997M6.36683 3.11811C6.43873 3.04782 6.55328 3.04782 6.62479 3.11811L18.4703 14.8225C19.9369 16.2734 20.6395 18.2771 20.3758 20.3588C20.1826 21.8848 19.3834 23.2752 18.2829 24.3627L6.62714 35.8815C6.55592 35.9518 6.44069 35.9518 6.36917 35.8815L3.15614 32.7058C3.08463 32.6358 3.08463 32.5217 3.15614 32.4513L14.7542 20.9896C15.1571 20.592 15.3792 20.0625 15.3792 19.4991C15.3792 18.9364 15.1571 18.4068 14.7542 18.0089L3.15516 6.54627C3.08365 6.47599 3.08365 6.36211 3.15516 6.29173L6.36683 3.11811Z"
    />
  ],
  viewBox
}

const IconCitygateChevron = Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconCitygateChevron'
})

export default IconCitygateChevron
